/** Persist list query so info/add/edit "List" can return with filters. */
export const PREPURCHASED_LICENSE_LIST_SEARCH_KEY =
  "prepurchased-license-list-search";

export const getPrepurchasedLicenseListPath = () => {
  const q = sessionStorage.getItem(PREPURCHASED_LICENSE_LIST_SEARCH_KEY) || "";
  return `/prepurchased-license${q}`;
};
